import { Record } from 'immutable';

import { SortOrder } from '.';

export enum IncludeMediaType {
  PRIMARY = 'primary',
  ALL = 'all'
}

export enum MediaAspectRatio {
  NATURAL = 'natural',
  SQUARE = 'square'
}

export enum MediaAdornment {
  ROUNDED = 'rounded',
  SQUARE = 'square'
}

export enum WatermarkLocationType {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
  TOP_LEFT = 'topLeft',
  TOP_RIGHT = 'topRight',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_RIGHT = 'bottomRight'
}

export enum WebPublishingAudience {
  API_AND_HUB = 'api_and_hub',
  API_ONLY = 'api_only'
}

export interface WebPublishingTheme {
  backgroundColor: string; // rgb string - the color used as the background color in all account pages
  bannerTextColor: string; // rgb string - the text color used with the account background image
}

export interface ThumbnailSlotCustomization {
  slot1?: string[];
  slot2?: string[];
  slot3?: string[];
}

export interface SortCustomization {
  path?: string;
  order?: SortOrder;
}

export interface WebPublishingCustomization {
  thumbnail?: ThumbnailSlotCustomization;
  sort?: SortCustomization;
}

// account settings controlling profile information to publish
export interface AccountPublishingType {
  name?: boolean;
  description?: boolean;
  location?: boolean;
  website_url?: boolean;
  avatar?: boolean;
  background?: boolean;

  [key: string]: boolean | undefined;
}

// TODO: This should become a VisitorFilterType ???:
export interface PropertiesFilterType {
  include?: string[][];
  exclude?: string[][];
}

export type EntryPublishingConfig = PropertiesFilterType;

export interface IndividualPublishingConfig {
  [classURI: string]: PropertiesFilterType;
}

export interface MediaPublishingType {
  watermarkText?: string;
  watermarkLocation?: WatermarkLocationType;
  include_media?: IncludeMediaType;
  media_aspect_ratio?: MediaAspectRatio;
  media_adornment?: MediaAdornment;
}

export interface WebPublishingType {
  on?: boolean;
  account?: AccountPublishingType;
  entry?: EntryPublishingConfig;
  individual?: IndividualPublishingConfig;
  media?: MediaPublishingType;

  theme?: WebPublishingTheme;
  audience?: WebPublishingAudience;

  customization?: WebPublishingCustomization;
}

export interface EntryWebPublishingType {
  on?: boolean;
  entry?: PropertiesFilterType;
  media?: MediaPublishingType;
}

export interface CollectionWebPublishingType {
  on?: boolean;
  euid_representative?: string;
  euid_representative_alignment?: 'top' | 'middle' | 'bottom';
}

export class CollectionWebPublishingRecord extends Record<CollectionWebPublishingType>(
  {
    on: undefined,
    euid_representative: undefined
  }
) {}

export interface IndividualWebPublishingType {
  on?: boolean;
  individual?: PropertiesFilterType;
  media?: MediaPublishingType;
}

export interface MediaWebPublishingType {
  on?: boolean;
}
